import { useState } from "react";
import { motion } from "framer-motion";
import { Expand, X } from "lucide-react";
import flyer from "@/assets/flyer.jpg";
import { CONTACT } from "@/lib/site";

export const Flyer = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="flyer" data-testid="flyer-section" className="relative py-24 sm:py-32 px-6 sm:px-10">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Ministry Launch</p>
          <h2 className="font-display text-4xl sm:text-6xl font-semibold text-[#F9F6F0] leading-tight mb-6">
            The Change <span className="gold-text italic">Is Coming</span>
          </h2>
          <p className="text-[#A19CA8] text-lg leading-relaxed mb-4">
            Help us build a church that changes lives and transforms our community through{" "}
            <span className="text-[#F9F6F0]">faith, love, and action</span>. Join us as we launch a new
            church home for all people.
          </p>
          <p className="text-[#A19CA8] leading-relaxed mb-8">
            Under the leadership of our Senior Servant,{" "}
            <span className="text-[#D4AF37] font-semibold">{CONTACT.pastor}</span>, we are preparing to
            open our doors in Clayton County.
          </p>

          <div className="grid grid-cols-2 gap-4 mb-8">
            {[
              "Bible-Centered Teaching",
              "Love In Action",
              "Stronger Together",
              "A Future Of Hope",
            ].map((v) => (
              <div key={v} className="flex items-center gap-2 text-[#A19CA8]">
                <span className="h-1.5 w-1.5 bg-[#D4AF37] rounded-full shrink-0" />
                <span className="text-sm">{v}</span>
              </div>
            ))}
          </div>

          <button
            onClick={() => setOpen(true)}
            data-testid="view-flyer-btn"
            className="inline-flex items-center gap-2 border-2 border-[#D4AF37] text-[#D4AF37] uppercase tracking-wider text-sm px-7 py-3 hover:bg-[#D4AF37]/10 transition-all"
          >
            <Expand className="h-4 w-4" /> View Full Flyer
          </button>
        </motion.div>

        <motion.button
          onClick={() => setOpen(true)}
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          data-testid="flyer-thumb"
          className="group relative block w-full overflow-hidden border border-[#D4AF37]/30 shadow-[0_20px_60px_rgba(0,0,0,0.6)]"
        >
          <img
            src={flyer}
            alt="The Change Center Church Ministry Launch flyer"
            className="w-full h-auto transition-transform duration-700 group-hover:scale-[1.03]"
          />
          <span className="absolute inset-0 bg-[#06040A]/0 group-hover:bg-[#06040A]/20 transition-colors flex items-center justify-center">
            <span className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-2 bg-[#06040A]/80 text-[#D4AF37] px-4 py-2 text-sm uppercase tracking-wider border border-[#D4AF37]/40">
              <Expand className="h-4 w-4" /> Tap To Enlarge
            </span>
          </span>
        </motion.button>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[100] bg-[#06040A]/95 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10"
          onClick={() => setOpen(false)}
          data-testid="flyer-modal"
        >
          <button
            onClick={() => setOpen(false)}
            data-testid="flyer-close"
            className="absolute top-6 right-6 text-[#D4AF37] hover:text-[#F3D56D] transition-colors"
            aria-label="Close"
          >
            <X className="h-8 w-8" />
          </button>
          <img
            src={flyer}
            alt="The Change Center Church Ministry Launch flyer"
            onClick={(e) => e.stopPropagation()}
            className="max-h-[90vh] w-auto border border-[#D4AF37]/40 shadow-2xl"
          />
        </div>
      )}
    </section>
  );
};
